import enLocale from 'element-ui/lib/locale/lang/en'
const en_us = {
    common:{
        lostTitle:"Warm reminder",
        lostContent: "The current network environment access rights are restricted. We are unable to provide services to mainland China. Please comply with the relevant regulations of your country and region to access our services.",
        connect:"Link",
        walletMsgPro:"Please use Binance Smart Chain Mainnet to log in",
        walletMsgTest:"Please use the Binance Smart Chain Testnet to log in",
        notice: "MPC Server Upgrade Notice",
        noticeContent1: "Dear Members:",
        noticeContent2: "Due to a power upgrade of the server, the MPC system will be temporarily unavailable from 00:00 on May 8, 2026 to 12:00 on May 8, 2026. Access will be restored immediately after the upgrade is completed. Please be aware of this.",
        balance:"Balance",
        approve:"Approve",
        sign: "Sign",
        confirmByWallet:"Confirm in wallet",
        language:"Language Settings",
        loading: "Loading...",
        confirm:"OK",
        cancel:"Cancel",
        copySuccess:"Copy successful",
        max:"Max",
        min:"Minimum ",
        amount:"Amount",
        all:"All",
        enterQuantity:"Enter quantity",
        day:"Day",
        noData: "No record yet",
        notStart:"Stay tuned",
        know: "Know",
        stcBalanceOut: "Insufficient STC balance in wallet",
        mpcBalanceOut: "Insufficient MPC balance in wallet",
        xlBalanceOut: "Insufficient XL balance in wallet",
        mineBalanceOut:"Insufficient MINE balance in wallet",
        usdtBalanceOut: "Insufficient USDT balance in wallet",
        test1BalanceOut:"Insufficient GTS balance in wallet",
        test2BalanceOut:"Insufficient APT balance in wallet",
        approveStcFail: "STC authorization failed",
        approveMpcFail: "MCP authorization failed",
        approveXlFail: "XL authorization failed",
        approveMineFail:"MINE authorization failed",
        approveUsdtFail: "USDT authorization failed",
    },
    home:{
        pledge: "Pledge", 
        node: "Node", 
        exchange: "Exchange", 
        my: "My"
    },
    pledge:{
        mode1: "STC+MPC Pledge",
        mode2: "MPC Pledge",
        mode3: "Merge Orders",
        ruleLabel: "Rules",
        mode1Msg: "Minimum investment: 100 STC + 100 USDT equivalent MPC; Purchase MPC and convert it to gold-based staking to obtain twice the equity value of the total investment amount. Gold-based staking accelerates the release of returns by 1%. Withdrawals are converted back to MPC at the real-time price. The staking amount increases by 1% daily from 100 STC.",
        mode2Msg: "Members without Star Coins can directly purchase 200 USDT equivalent MPC for staking to obtain twice the equity value of the total investment amount. Gold-based staking accelerates the release of returns by 1%. Withdrawals are converted back to MPC at the real-time price.",
        mpcPrice: "MPC Price",
        myOrder: "My Orders",
        time: "Time",
        amount: "Quantity",
        value: "Value",
        profit:"Profit",
        outOrderLimit: "A maximum of 100 orders per account",
        pledgeSuccess:"Pledge successful",
        pledgeFail:"Pledge failed"
    },
    node:{
        title: "Node Upgrade",
        msg: "Becoming a community node, super node, or genesis node not only grants double the revenue rights, but also faster acceleration of reward release and additional node dividend rewards.",
        node3: "Community Node",
        node4: "Super Node",
        node5: "Genesis Node",
        node6: "Meta Node",
        nodeProfit3: "Receive 20% Accelerated Release Reward for New Accounts",
        nodeProfit4: "Receive 25% Accelerated Release Reward for New Accounts",
        nodeProfit5: "Receive 30% Accelerated Release Reward for New Accounts",
        nodeProfit6: "Receive 40% Accelerated Release Reward for New Accounts",
        nodeTask3: "Destroy one token (1000 MPC);",
        nodeTask4: "Destroy one token (5000 MPC);",
        nodeTask5: "Destroy one token (10000 MPC);",
        nodeTask6: "Destroy one token (50000 MPC);",
        task: "Task",
        task1: "Task 1",
        task2: "Task 2",
        inviteTask: "Directly refer 10 valid members;",
        finish: "Completed",
        execute: "Execute",
        nodeBonus: "Node Dividend",
        takeAmt: "Received",
        waitAmt: "Pending",
        takeBonus: "Receive",
        needPay: "Payment Required ", 
        plsFinishTask1: "Please complete Task 1 first!",
        upgradeSuccess: "Upgrade successful!",
        upgradeFail: "Upgrade failed!",
        noBonus: "No dividends available",
        takeSuccess: "Claim successful!",
        takeFail: "Claim failed!",
        node0SoldOut: "Community nodes are sold out",
        node1SoldOut: "Super nodes are sold out",
        node2SoldOut: "Genesis nodes are sold out",
        node3SoldOut: "Meta nodes are sold out",
        orderList: "Node orders",
        nodeOrder3: "Community Node Order",
        nodeOrder4: "Super Node Order",
        nodeOrder5: "Genesis Node Order",
        nodeOrder6: "Meta Node Order",
    },
    exchange:{
        title:"Exchange",
        notOpen:"Not open, Stay tuned !",
        plsInputAmt:"Please enter the exchange quantity",
        exchangeSuccess:"Exchange successful",
        exchangeFail:"Exchange failed",
        price:"Price",
        fee:"Fee",
        myLogList: "My Exchanges",
        myTotalUsdt: "Total",
        usdtAmt: "USDT Amount",
        time: "Time",
        mpcAmt: "MPC Amount",
    },
    my:{
        myProfit:"My Profit",
        pledgeTotal: "Pledge Remain", 
        pledgeWait: "Pledge Released", 
        nodeTotal: "Node Remain", 
        nodeWait: "Node Released",
        exchange:"Exchange",
        myInviteUrl:"My Invitation Link",
        bindCode:"Bound Invitation Code",
        notBind:"Unbound",
        myTeam:"My Team",
        address:"Address",
        hasActive: "Activated", 
        notActive: "Invalid",
        time:"Time",
        buyVal:"Total Pledge",
        noProfit:"No Profits Available for Exchange",
        exchangeSuccess:"Exchange Successful",
        exchangeFail:"Exchange Failed",
        aboutUs: "About Us", 
        foundation: "Foundation"
    },
    bind:{
        title:"Bind Invitation Code",
        holder:"Enter invitation code",
        confirm:"Confirm",
        errorCode:"Invitation code error",
        cannotBeSelf:"Cannot bind your own invitation code",
        cannotBeChild: "Disables circular binding",
        bindSuccess:"Binding successful",
        bindFail:"Binding failed"
    },
    ...enLocale
}
export default en_us